export const environment = {
  client_image_url: '../../../../assets/client/',
  admin_image_url: '../../../../assets/admin/',
  url: 'https://dev-raivaluate-admin-api.solutionanalysts.us/api/v1/',
  erm_token_url: 'http://54.173.192.200/oauth2/',
  erm_url: 'http://54.173.192.200/apis/default/api/',
};
